import React, { useEffect, useMemo, useState } from 'react';

import {
  useGetLivestreamingTopDomainsQuery,
  useGetLivestreamingTopIspsQuery,
} from '../../redux/apis/analyticsManagement/aMLiveStreamingStatsApiSlice';
import BarChart from '../other/charts/BarChart';
import ComponentLoader from '../other/ComponentLoader';
import { Card, CardBody } from '../other/card/card';
import { rowsToBarChartData } from './livestreamingBarHelpers';

const CHART_HEIGHT = '380px';
const queryOpts = { refetchOnMountOrArgChange: true };

const LiveStreamingTopDomainsPanel = ({ chartThemeKey = 0 }) => {
  const { data, isLoading, isError, error } = useGetLivestreamingTopDomainsQuery(undefined, queryOpts);
  const barData = useMemo(() => rowsToBarChartData(data, 'domain', 'reported'), [data]);
  const hasData = Object.keys(barData).length > 0;
  const errorMessage = error?.data?.message;

  return (
    <div className='relative'>
      {isLoading ? <ComponentLoader /> : null}
      {isError ? (
        <div className='absolute inset-0 d-flex items-center justify-center p-3 text-danger small bg-white bg-opacity-75 z-1'>
          Failed to load.
          {errorMessage ? ` ${errorMessage}` : ''}
        </div>
      ) : null}

      <p className='text-center font-medium mb-2'>Top Reported Domains</p>
      {!isError && !hasData && !isLoading ? (
        <p className='text-center small text-inverse text-opacity-50'>No domain data.</p>
      ) : !isError && hasData ? (
        <BarChart key={`ls-domains-${chartThemeKey}`} data={barData} height={CHART_HEIGHT} />
      ) : null}
    </div>
  );
};

const LiveStreamingTopIspsPanel = ({ chartThemeKey = 0 }) => {
  const { data, isLoading, isError, error } = useGetLivestreamingTopIspsQuery(undefined, queryOpts);
  const barData = useMemo(() => rowsToBarChartData(data, 'isp', 'reported'), [data]);
  const hasData = Object.keys(barData).length > 0;
  const errorMessage = error?.data?.message;

  return (
    <div className='relative'>
      {isLoading ? <ComponentLoader /> : null}
      {isError ? (
        <div className='absolute inset-0 d-flex items-center justify-center p-3 text-danger small bg-white bg-opacity-75 z-1'>
          Failed to load.
          {errorMessage ? ` ${errorMessage}` : ''}
        </div>
      ) : null}

      <p className='text-center font-medium mb-2'>Top reported ISPs</p>
      {!isError && !hasData && !isLoading ? (
        <p className='text-center small text-inverse text-opacity-50'>No ISP data.</p>
      ) : !isError && hasData ? (
        <BarChart key={`ls-isps-${chartThemeKey}`} data={barData} height={CHART_HEIGHT} />
      ) : null}
    </div>
  );
};

const LiveStreamingTopDomainsAndIsps = () => {
  const [chartThemeKey, setChartThemeKey] = useState(0);

  useEffect(() => {
    const onThemeReload = () => setChartThemeKey(k => k + 1);
    document.addEventListener('theme-reload', onThemeReload);
    return () => document.removeEventListener('theme-reload', onThemeReload);
  }, []);

  return (
    <div className='row g-2 mt-1'>
      <div className='col-12'>
        <Card className='mb-0'>
          <CardBody className='relative p-0'>
            <div className='p-4'>
              <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
                <LiveStreamingTopDomainsPanel chartThemeKey={chartThemeKey} />
                <LiveStreamingTopIspsPanel chartThemeKey={chartThemeKey} />
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default LiveStreamingTopDomainsAndIsps;
